module.exports = __webpack_public_path__ + "img/justify-right.3e5a2a71.svg";